export function isReturnToCollection(referrer) {
    if (!referrer) return false
    try {
        return /^\/collection(?:\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})?\/?$/i.test(new URL(referrer).pathname)
    } catch (err) {
        return false
    }
}

export function canRestoreCollection() {
    return window.history.length > 1 && isReturnToCollection(document.referrer)
}

export function initCollectionBackNav(root) {
    const link = (root || document).querySelector(
        '.event-page-v2-header a[data-header-back]'
    )
    if (!link || link.dataset.backNavWired) return
    link.dataset.backNavWired = 'true'
    link.addEventListener('click', (e) => {
        if (
            e.defaultPrevented ||
            e.button !== 0 ||
            e.metaKey ||
            e.ctrlKey ||
            e.shiftKey ||
            e.altKey
        )
            return
        if (canRestoreCollection()) {
            e.preventDefault()
            window.history.back()
        }
    })
}
